import { NewPastePage } from './pages/NewPaste';
import { ViewPastePage } from './pages/ViewPaste';
import { RegisterPage } from './pages/Register';
import { LoginPage } from './pages/Login';
import { MyPastesPage } from './pages/MyPastes';
import { EditPastePage } from './pages/EditPaste';
import { NotFoundPage } from './pages/NotFound';

type RouteHandler = () => void;

const routes: Record<string, RouteHandler> = {
    '/': NewPastePage,
    '/new': NewPastePage,
    '/register': RegisterPage,
    '/login': LoginPage,
    '/me': MyPastesPage,
};

function getRoute(path: string): RouteHandler | null {
    // Check exact match first
    if (routes[path]) return routes[path];

    // Check paste edit: /edit/{id}
    const editMatch = path.match(/^\/edit\/([a-zA-Z0-9]{8,24})$/);
    if (editMatch) {
        return () => EditPastePage(editMatch[1]);
    }

    // Check paste view: /paste/{id}
    const pasteMatch = path.match(/^\/paste\/([a-zA-Z0-9]{8,24})$/);
    if (pasteMatch) {
        return () => ViewPastePage(pasteMatch[1]);
    }

    return null;
}

function navigate(path: string): void {
    history.pushState({}, '', path);
    handleRoute();
}

function handleRoute(): void {
    const path = window.location.pathname;
    const handler = getRoute(path);

    const app = document.getElementById('app');
    if (app) app.innerHTML = '';

    if (handler) {
        handler();
    } else {
        NotFoundPage();
    }
}

export function initRouter(): void {
    window.addEventListener('popstate', handleRoute);
    handleRoute();
}

export { navigate };
